import type { PerformanceProFeatureValue } from '@/constants/PerformanceProFeature';

/** The window event the Engagement host listens to, to open its Performance PRO upgrade pop-up. */
export const PERFORMANCE_UPGRADE_EVENT = 'performance-upgrade';

export interface PerformanceUpgradeRequest {
    /** The locked feature the reader clicked; the host names it in the pop-up. */
    feature: PerformanceProFeatureValue;
}

/**
 * Asks the host to offer Performance PRO for a locked feature. The pop-up and the request-info
 * window it leads to belong to the host, which owns the subscription flow; a window event reaches it
 * from inside the shadow root the same way `mfe-navigate` does. With no host listening (standalone
 * `yarn dev`, tests) the request simply goes unanswered.
 */
export const requestPerformanceUpgrade = (feature: PerformanceProFeatureValue): void => {
    window.dispatchEvent(
        new CustomEvent<PerformanceUpgradeRequest>(PERFORMANCE_UPGRADE_EVENT, {
            detail: { feature },
        }),
    );
};
